import React, {
  createContext,
  useCallback,
  useState,
  useContext,
  useEffect,
} from 'react';
import api from '../services/api';

import { IOption } from '../components/SelectSync';
import { User } from './auth';
import { useToast } from './toast';
import getResponseErrors from '../utils/getResponseErrors';

type IMedico = User;

interface MedicoContextData {
  loading: boolean;
  optionsMedico: IOption[];
  buscaOptionsMedico(): Promise<void>;
  limparMedico(): void;
}

const MedicoContext = createContext<MedicoContextData>({} as MedicoContextData);

const MedicoProvider: React.FC = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const { addToast } = useToast();

  const [optionsMedico, setOptionsMedico] = useState<IOption[]>(() => {
    const optionsMedicos = localStorage.getItem('@AgendaFacil:optionsMedico');
    if (optionsMedicos) return JSON.parse(optionsMedicos);

    return [] as IOption[];
  });

  const buscaOptionsMedico = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get<IMedico[]>(`/medicos`);

      const options = response.data.map((op: IMedico) => ({
        value: op.UsuCodigo.toString(),
        label: op.UsuNome,
      }));

      localStorage.setItem(
        '@AgendaFacil:optionsMedico',
        JSON.stringify(options),
      );

      setOptionsMedico(options);
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Não foi possível carregar médicos',
        type: 'error',
        description: mensagemErro,
      });
    } finally {
      setLoading(false);
    }
  }, [addToast]);

  useEffect(() => {
    async function load(): Promise<void> {
      const tokenLocal = localStorage.getItem('@AgendaFacil:token');
      if (tokenLocal) {
        buscaOptionsMedico;
      }
    }
    load();
  }, [buscaOptionsMedico]);

  const limparMedico = useCallback(() => {
    localStorage.removeItem('@AgendaFacil:optionsMedico');
    setOptionsMedico([]);
  }, []);

  return (
    <MedicoContext.Provider
      value={{
        loading,
        buscaOptionsMedico,
        optionsMedico,
        limparMedico,
      }}
    >
      {children}
    </MedicoContext.Provider>
  );
};

function useMedico(): MedicoContextData {
  const context = useContext(MedicoContext);

  if (!context) {
    throw new Error('useMedico deve ser usado com o MedicoProvider');
  }

  return context;
}

export { MedicoProvider, useMedico };
